import api from './base/BaseApi';
import { TAccountPicture } from '@/services/types/Account';
import { handleApiError } from '@/services/base/handleApiError';

export const retrievePicture = async (id: string, type: string) =>
  api
    .get<TAccountPicture>(`api/v1/display-pictures?id=${id}&type=${type}`)
    .then((response) => response)
    .catch(handleApiError);

/**
 * A team member's photo lives behind its own endpoint, not the generic one above - viewing
 * someone else's photo (not your own) needs the admin-scoped business/customer permission check
 * that only this endpoint applies.
 */
export const getTeamMemberDisplayPicture = async (businessId: string, customerId: string) => {
  const params = new URLSearchParams({ businessId, customerId });
  return api
    .get<TAccountPicture>(`api/v1/display-pictures/team-members?${params.toString()}`)
    .then((response) => response)
    .catch(handleApiError);
};
